import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { delegationsdto } from 'app/models/delegationsdto';
import { AuthWebService } from 'app/services/authweb.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { WorkflowService } from 'app/services/workflow.service';
import { INT_WFDELEGATIONS, WFDELEGATION } from 'app/shared/actions/actions.constants';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-wfdelegation',
  templateUrl: './wfdelegation.component.html',
  styleUrls: ['./wfdelegation.component.scss']
})
export class WfdelegationComponent implements OnInit {
  delegationsdto: delegationsdto = new delegationsdto;
  delegations: any = [];
  wfroles: any = [];
  filtered_wfroles: any = [];
  selectedData: any = null;
  selectedDelegationData: any = null;
  isLoading: boolean = false;
  lblHeading = "Workflow Delegations";
  user: any = {};
  mode:any = 'Add';

  wfDelegationActions = INT_WFDELEGATIONS;

  constructor(private service: WorkflowService, private toaster: ToastNotificationService, 
    private authWebService: AuthWebService, private datePipe: DatePipe,
    public utility: UtilityServiceService, private dialog: ConfirmDialogService) { }

  ngOnInit(): void {
    this.user = this.authWebService.userData.User
    this.getWFRoleUsers();
  }

  //#region General
  onChecked(event, item){
    if (event.target.checked) {
      this.selectedDelegationData = item;
    } else {
      this.selectedDelegationData = null;
    }
  }

  doAction(event: any) {
    const button = document.getElementById("popupButton") as HTMLButtonElement;
    if (event.value == WFDELEGATION.AddWFDelegation) {
      if(this.wfroles.length > 0){
        this.lblHeading = "Add Delegation";
        this.mode = 'Add';
        this.delegationsdto = new delegationsdto;
        button.click();
      }else{
        this.toaster.error("Failed to load workflow users. Please contact support","Delegation")
      }      
    } else if (event.value == WFDELEGATION.DeleteWFDelegation) {
      if(this.selectedDelegationData == null){
         this.toaster.error("Please select the record first!","Delete")
       }else{
        this.delegationsdto = this.selectedDelegationData;
         this.onDelete();
       }
    } else if (event.value == WFDELEGATION.EditWFDelegation) {
      this.lblHeading = "Edit Delegation";
      this.mode = 'Edit';
      if(this.selectedDelegationData == null){
        this.toaster.error("Please select the record first!","Edit")
      }else{
        console.log(this.selectedDelegationData)
        this.mode = 'Edit';
        this.delegationsdto = this.selectedDelegationData;
        this.onDelegateSelected();
        button.click();
      }
    }
  }

  getWFRoleUsers(){
    this.isLoading = true;
    this.service.getWorkflowUsers().subscribe(
      (result) => {
        this.wfroles = result;
        this.isLoading = false;
        this.getDelegations()
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onDelegateSelected(){
    let selectedroleusers = this.wfroles.filter((x:any) => x.userName == this.delegationsdto.awayuser)[0].roleID;
    this.filtered_wfroles = this.wfroles.filter((x:any) => x.roleID == selectedroleusers && x.userName != this.delegationsdto.awayuser);
  }
  //#endregion

  //#region CRUD
  getDelegations(){
    this.isLoading = true;
    this.service.getDelegations().subscribe(
      (result) => {
        this.setDelegationData(result);
        this.isLoading = false;
      },
      (error) => {
        this.selectedDelegationData = null;
        this.delegations = [];
        if(error.status != 404){
          this.toaster.error(
            "Failed to load delegations. Please try again",
            "Delegations"
          );
        }        
        this.isLoading = false;
      }
    );

  }

  setDelegationData(data){
    this.selectedDelegationData = null;
    this.delegations = [];
    data.forEach(item => {
      const obj = {
        unavailableusersid: item.unavailableusersid,
        usercreated: item.usercreated,
        datecreated: item.datecreated,
        userupdated:  item.userupdated,
        dateupdated:  item.dateupdated,
        deletedyn: item.deletedyn,
        awayuser: item.awayuser,
        awayuserdisplayname: this.wfroles.find((p:any) => p.userName==item.awayuser).displayName,
        awayfrom: item.awayfrom,
        awayto: item.awayto,
        delegateyn: item.delegateyn,
        delegateuser: item.delegateuser,
        delegateuserdisplayname: this.wfroles.find((p:any) => p.userName==item.delegateuser).displayName
      }

      this.delegations.push(obj);
    });


  }

  onAdd(){

    this.delegationsdto.awayto = this.delegationsdto.awayto['year'] + "-" + ((this.delegationsdto.awayto['month'] > 9) ? this.delegationsdto.awayto['month'] : ("0"+this.delegationsdto.awayto['month'])) + "-" + this.delegationsdto.awayto['day'];
    this.delegationsdto.awayfrom = this.delegationsdto.awayfrom['year'] + "-" + ((this.delegationsdto.awayfrom['month'] > 9) ? this.delegationsdto.awayfrom['month'] : ("0"+this.delegationsdto.awayfrom['month'])) + "-" + this.delegationsdto.awayfrom['day'];

    if(this.delegations.find(x=>x.awayuser==this.delegationsdto.awayuser)){
      this.toaster.error("Delegation for this user already exists!","Delegation");
      this.delegationsdto.awayfrom = undefined;
      this.delegationsdto.awayto = undefined;
      return;
    }

    if(this.datePipe.transform(this.delegationsdto.awayfrom,'yyyy-mm-dd') > this.datePipe.transform(this.delegationsdto.awayto,'yyyy-mm-dd')){
      this.toaster.error("Start date cannot be greater than end date","Delegation");
      this.delegationsdto.awayfrom = undefined;
      this.delegationsdto.awayto = undefined;
      return;
    }

    if(this.delegationsdto.delegateyn == true && !this.delegationsdto.delegateuser){
      this.toaster.error("Delegate user not selected. Please selected delegate or select 'No'","Delegation");
      this.delegationsdto.awayfrom = undefined;
      this.delegationsdto.awayto = undefined;
      return;
    }

    this.delegationsdto.usercreated = this.user.Id;
    this.delegationsdto.datecreated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.delegationsdto.userupdated = this.user.Id;
    this.delegationsdto.dateupdated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.delegationsdto.deletedyn = false;
    this.delegationsdto.awayfrom = this.datePipe.transform(this.delegationsdto.awayfrom, 'yyyy-MM-dd');
    this.delegationsdto.awayto = this.datePipe.transform(this.delegationsdto.awayto, 'yyyy-MM-dd');

    this.isLoading = true;
    this.service.addDelegations(this.delegationsdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Delegation successfully added","Delegation");
        this.getDelegations();
      },
      (error) => {
        this.toaster.error(
          "Failed to save delagation. Please try again",
          "Delegation"
        );
        this.isLoading = false;
      }
    ); 
  }

  onUpdate(){

    if(this.delegationsdto.awayfrom['year']==undefined){
      this.toaster.error("Please select 'Away from' date","Delegation");
      return;
    }

    if(this.delegationsdto.awayto['year']==undefined){
      this.toaster.error("Please select 'Away until' date","Delegation");
      return;
    }

    this.delegationsdto.awayto = this.delegationsdto.awayto['year'] + "-" + ((this.delegationsdto.awayto['month'] > 9) ? this.delegationsdto.awayto['month'] : ("0"+this.delegationsdto.awayto['month'])) + "-" + this.delegationsdto.awayto['day'];
    this.delegationsdto.awayfrom = this.delegationsdto.awayfrom['year'] + "-" + ((this.delegationsdto.awayfrom['month'] > 9) ? this.delegationsdto.awayfrom['month'] : ("0"+this.delegationsdto.awayfrom['month'])) + "-" + this.delegationsdto.awayfrom['day'];

    if(this.datePipe.transform(this.delegationsdto.awayfrom,'yyyy-mm-dd') > this.datePipe.transform(this.delegationsdto.awayto,'yyyy-mm-dd')){
      this.toaster.error("Start date cannot be greater than end date","Delegation");
      this.delegationsdto.awayfrom = undefined;
      this.delegationsdto.awayto = undefined;
      return;
    }

    if(this.delegationsdto.delegateyn == true && !this.delegationsdto.delegateuser){
      this.toaster.error("Delegate user not selected. Please selected delegate or select 'No'","Delegation");
      this.delegationsdto.awayfrom = undefined;
      this.delegationsdto.awayto = undefined;
      return;
    }

    this.isLoading = true;
    this.service.updateDelegations(this.delegationsdto.unavailableusersid, this.delegationsdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Delegation successfully updated","Delegation");
        this.getDelegations();
      },
      (error) => {
        this.toaster.error(
          "Failed to update delegation. Please try again",
          "Delegation"
        );
        this.isLoading = false;
      }
    );
  }

  onDelete(){
    this.dialog.confirmThis(`Are you sure you want to delete this delegation.`,
    () => {
      this.isLoading = true;      
      this.service.deleteDelegations(this.delegationsdto.unavailableusersid).subscribe(
        (result) => {
          this.getDelegations();
          this.toaster.success("Delegation successfully deleted","Delegation");
        },
        (error) => {
          this.toaster.error(
            "Failed to update delegation. Please try again",
            "Delegation"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      this.isLoading = false;
      return;
    }
  );

  }
  //#endregion
}
